import { styled } from 'styled-components';

export const Container = styled.div(({ theme }) => ({
  textAlign: 'right',
  display: 'grid',
  gap: '8rem',
  gridTemplateColumns: '2fr 1fr',
  color: theme.palette.green,
  fontSize: theme.typography.size14,
  cursor: 'pointer',

  [theme.breakpoint.media.max.sm]: {
    paddingInline: '24rem',
  },
}));

export const Label = styled.div({});

export const Value = styled.div({});

export const Input = styled.input(({ theme }) => ({
  width: '100%',
  textAlign: 'right',
  fontSize: theme.typography.size14,
  border: `1rem solid ${theme.palette.lightGray}`,
  borderRadius: '4rem',
  padding: '2rem 4rem',
  outline: 'none',
  '&:focus': {
    borderColor: theme.palette.green,
  },
}));
